import { Edit, ExpandMore, Menu, Phone, Print } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Collapse,
  Divider,
  IconButton,
  List,
  Stack,
  Typography,
  Zoom,
} from "@mui/material";
import { green, grey } from "@mui/material/colors";
import { useState } from "react";

function Cards() {
  const people = [
    {
      id: 1,
      first_name: "Ariana",
      last_name: "Grande",
      department: "Office",
      section: "Packaging",
      isLogged: true,
    },
    {
      id: 2,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
    },
    {
      id: 3,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
    },
    {
      id: 4,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
    },
    {
      id: 5,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
    },
    {
      id: 6,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
    },
    {
      id: 7,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
    },
    {
      id: 8,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
    },
    {
      id: 9,
      first_name: "Solomon",
      last_name: "Wiseman",
      department: "OutSource",
      section: "Transport",
      isLogged: false,
    },
  ];

  const [details, setDetails] = useState(null);
  //handling details
  const handleDetails = (person) => {
    setDetails(<Details person={person} />);
  };

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
        <Typography variant="h6">Cards</Typography>
        <Divider variant="middle" />
        <Box display={"flex"} columnGap={2}>
          <Stack
            display={"flex"}
            justifyContent={"start"}
            width={"35%"}
            style={{ maxHeight: 500, overflow: "auto" }}
          >
            <List>
              {people.map((person) => {
                return (
                  <Zoom
                    in={true}
                    style={{ transitionDelay: "200ms" }}
                    key={person.id}
                  >
                    <Card elevation={2} sx={{ width: "100%", my: 1 }}>
                      <CardActionArea onClick={() => handleDetails(person)}>
                        <CardContent>
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            columnGap={2}
                          >
                            <Avatar>{person.first_name[0]}</Avatar>
                            <Typography variant="body1">
                              {person.first_name} {person.last_name}
                            </Typography>
                          </Box>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </Zoom>
                );
              })}
            </List>
          </Stack>
          <Stack my={1} width={"60%"}>
            {details}
          </Stack>
        </Box>
      </Stack>
    </Zoom>
  );
}

export default Cards;

function Details(props) {
  const { person } = props;

  const [collapse, setCollapse] = useState(false);

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack rowGap={1}>
        <Card>
          <CardActions sx={{ justifyContent: "end" }}>
            <IconButton>
              <Print />
            </IconButton>
            <IconButton>
              <Menu />
            </IconButton>
          </CardActions>
          <CardContent sx={{display:"flex", flexDirection:'column', rowGap:1, bgcolor:green[50], borderRadius:4}}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              height={"50%"}
              borderRadius={4}
              bgcolor={grey[800]}
              columnGap={2}
              padding={2}
            >
              <Stack>
                <Typography variant="h6" color={grey[50]}>
                  Kadesea Agency Limited
                </Typography>
                <Typography variant="h6" color={grey[50]}>
                  P.O Box 30200 - 010
                </Typography>
                <Typography variant="h6" color={grey[50]}>
                  Kitale
                </Typography>
              </Stack>
              <Avatar
                src="https://cdn.pixabay.com/photo/2017/05/22/07/20/woman-2333326_640.jpg"
                sx={{ width: 96, height: 96 }}
              >
                IMG
              </Avatar>
              <Stack>
                <Typography variant="body1" color={grey[50]}>
                  {person.first_name} {person.last_name}
                </Typography>
                <Typography variant="body1" color={grey[50]}>
                  Department - {person.department}
                </Typography>
                <Typography variant="body1" color={grey[50]}>
                  Section - {person.section}
                </Typography>
              </Stack>
            </Box>
            <Box
              display={"flex"}
              height={"50%"}
              borderRadius={4}
              bgcolor={grey[500]}
              columnGap={2}
              padding={2}
            >
              <Stack >
                <Typography variant="h6" color={grey[50]}>
                  Company :
                </Typography>
                <Typography variant="h6" color={grey[50]}>
                  Location
                </Typography>
                <Typography variant="h6" color={grey[50]}>
                  Job Group
                </Typography>
              </Stack>
              <Stack ml={'auto'}>
                <Typography variant="h6" color={grey[50]}>
                  Employement Number :
                </Typography>
                <Typography variant="h6" color={grey[50]}>
                  ID Number
                </Typography>
                <Typography variant="h6" color={grey[50]}>
                  Gender
                </Typography>
              </Stack>
            </Box>
          </CardContent>
        </Card>
        
      </Stack>
    </Zoom>
  );
}
